import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getTenantBranding, updateTenantBranding } from "api/tenantApi";

/**
 * @typedef {Object} BrandingState
 * @property {string} companyName
 * @property {string} primaryColor
 * @property {string} secondaryColor
 * @property {string} logoUrl
 * @property {boolean} loaded
 */

/** @type {BrandingState} */
export const initialState = {
  companyName: "Kerico Care",
  primaryColor: "#1173F5",
  secondaryColor: "#284A70",
  logoUrl: "",
  loaded: false,
};

export const fetchBranding = createAsyncThunk(
  "branding/fetchBranding",
  async (_, { rejectWithValue }) => {
    const result = await getTenantBranding();
    if (result.error) {
      return rejectWithValue(result.error);
    }
    return result.value;
  }
);

export const saveBranding = createAsyncThunk(
  "branding/saveBranding",
  async (payload, { rejectWithValue }) => {
    const result = await updateTenantBranding(payload);
    if (result.error) {
      return rejectWithValue(result.error);
    }
    return result.value;
  }
);

const brandingSlice = createSlice({
  name: "branding",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBranding.fulfilled, (state, { payload }) => ({
      companyName: payload.companyName || state.companyName,
      primaryColor: payload.primaryColor || state.primaryColor,
      secondaryColor: payload.secondaryColor || state.secondaryColor,
      logoUrl: payload.logoUrl || "",
      loaded: true,
    }));
    builder.addCase(fetchBranding.rejected, (state) => ({
      ...state,
      loaded: true,
    }));
    builder.addCase(saveBranding.fulfilled, (state, { payload }) => ({
      ...state,
      companyName: payload?.companyName || state.companyName,
      primaryColor: payload?.primaryColor || state.primaryColor,
      secondaryColor: payload?.secondaryColor || state.secondaryColor,
      logoUrl: payload?.logoUrl ?? state.logoUrl,
      loaded: true,
    }));
  },
});

export default brandingSlice.reducer;
